<script setup lang="ts">
import { CreateButton, IconItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types'
import { useWindowSize } from '@vueuse/core'
import { computed, ref } from 'vue'

type Emits = {
    (e: 'click', value: boolean): void
}
const emit = defineEmits<Emits>()

const editMode = ref(false)
const handleDialogOpen = (value: boolean) => {
    editMode.value = value
    emit('click', value)
}
const { width } = useWindowSize()
const isCompactView = computed(() => width.value < 1100)
</script>

<template>
    <CreateButton
        v-if="!isCompactView"
        :label="
            editMode
                ? $t('event.button.saveCheckpointOrder')
                : $t('event.button.editCheckpointOrder')
        "
        @click="handleDialogOpen(!editMode)"
        class="anim-btn"
        v-bind="$attrs" />
    <div
        v-else
        @click="handleDialogOpen(!editMode)"
        class="inline-flex items-center justify-center bg-orange-500 text-white px-3 py-1 rounded-lg hover:bg-orange-600 duration-300 ease-in-out cursor-pointer"
        v-bind="$attrs">
        <IconItem :icon="editMode ? 'content-save' : 'sort'" :type="EColors.WHITE" />
    </div>
</template>
